import { Stack, Typography as MuiTypography } from '@mui/material';

export const DsTypography = () => {
  return (
    <Stack spacing={2}>
      <MuiTypography variant="h2">Typography</MuiTypography>
      <Stack spacing={1}>
        <MuiTypography variant="h1">h1. Headline 1</MuiTypography>
        <MuiTypography variant="h2">h2. Headline 2</MuiTypography>
        <MuiTypography variant="h3">h3. Headline 3</MuiTypography>
        <MuiTypography variant="body1">Body 1</MuiTypography>
        <MuiTypography variant="body2">Body 2</MuiTypography>
      </Stack>
    </Stack>
  );
};
